export enum VictorQaClasses {
    oneHeader = 'qa-one-header',
    helpCenterBurgerItem = 'qa-blockSuggest__helpCenterLink',
    looksNavItemShort = 'qa-nav-item-look-short',
    looksNavItemLong = 'qa-nav-item-look-long',
    looksNavFlyout = 'qa-nav-flyout-look',
    looksNavFlyoutLink = 'qa-nav-flyout-look--link',
    headerSignUpLink = 'qa-header__sign-up-link',
    headerAccountLink = 'qa-header-account-link',
    headerWishlistLink = 'qa-header-wishlist-link',
    headerWishlistCounter = 'qa-header-wishlist-counter',
    headerCartLink = 'qa-header-cart-link',
    headerCartCounter = 'qa-header-cart-counter',
    headerClubTab = 'qa-header-club-tab',
    headerBurgerMenuAccountItem = 'qa-header-menu-account-link',
    headerBurgerMenuLoginItem = 'qa-header-menu-login-link',
    headerBurgerMenuContainer = 'qa-header-menu-container',
    headerBurgerMenuIcon = 'qa-header-menu-icon',
    headerMenuLink = 'qa-header-menu-link',
    headerSearchIcon = 'qa-header-search-icon',
    headerSearchInput = 'qa-header-search-input',
    headerSearchInputClearIcon = 'qa-header-search-input-clear-icon',
    headerSearchSuggestionFlyout = 'qa-header-search-suggestion-flyout',
    headerSearchSuggestion = 'qa-header-search-suggestion',
    headerPromotionBanner = 'qa-header-promotion-banner',
    headerHelpCenterLink = 'qa-header-helpcenter-link',
    headerHelpCenterFlyout = 'qa-header-helpcenter-flyout',
    headerAccountFlyout = 'qa-header-account-flyout',
    headerNavItem = 'qa-header-nav-item',

    accountMenuReviews = 'qa-header-account-menu-reviews',
    accountMenuOrders = 'qa-header-account-menu-orders',
    accountMenuOverview = 'qa-header-account-menu-overview',
    accountMenuAddress = 'qa-header-account-menu-addresses',
    accountMenuNewletter = 'qa-header-account-menu-newsletters',
    accountMenuWishlist = 'qa-header-account-menu-wishlist',
    accountMenuVoucher = 'qa-header-account-menu-vouchers',
    accountMenuMyLooks = 'qa-header-account-menu-my-looks',

    partialLoginOverlayEmail = 'qa-partial-login-overlay-email',
    partialLoginOverlayPassword = 'qa-partial-login-overlay-password',
    partialLoginOverlaySubmit = 'qa-partial-login-overlay-submit',

    selectorItem = 'selector__DropDownItem',
}

export enum BellaTestIds {
    menuItem = 'menu-item',
    note = 'note',
    externalMenuItem = 'external-menu-item',
    menuNavitem = 'menu-cat-nav-item',
    burgerMenuNavitem = 'burger-menu-cat-nav-item',
    categoryFiltergroup = 'facet_category_keys',
    priceFiltergroup = 'facet_price',
    brandFiltergroup = 'facet_brand_keys',
    materialFiltergroup = 'facet_mat_filter',
    colorFiltergroup = 'facet_col',
    categoryFilterItem = 'category-filter-item',
    brandFilterItem = 'brand-filter-item',
    radioBtnLabel = 'radio-btn-label',
    filterCount = 'filter-count',
    productPrice = 'product-price',
    loginRegSubmitBtn = 'login_reg_submit_btn',
    loginRegSwitchBtn = 'login_reg_switch_btn',
    filtersApplyBtn = 'filters_apply_btn',
    filtersResetBtn = 'filters_reset_btn',
    footerLinks = 'footer-links',
    ratingStar = 'rating-star',
    headerCartCounter = 'cart-counter',
    strikeThroughPrice = 'strike-through-price',
    desktopFilterContainer = 'desktop-filter-container',
    moreFiltersButton = 'more-filters-btn',
    pdpWishlistIcon = 'pdp-wishlish-icon',
    pdpWishlistBadge = 'pdp-wishlist-badge',
    notificationBanner = 'notification-banner',
    notificationBannerDismissButton = 'dismiss-notification-button',
    searchInput = 'search-input',
    searchButton = 'search-button',
    searchButtonWrapper = 'search-button-wrapper',
    searchInputIcon = 'search-input-icon',
    searchInputClearIcon = 'search-input-dismiss-click',
    homepageNewProducts = 'homepage-new-products-slider',
    homepageCategorySlider = 'homepage-category-slider',
    homepageSecondaryBanner = 'homepage-secondary-banner',
    homepageBestSellerProducts = 'homepage-bestseller-products-slider',
    homePageHeroBanner = 'homepage-hero-banner',
    homePageContentWrapper = 'homepage-content-wrapper',
    homePagePlacingBannersWrapper = 'homepage-placing-banners-wrapper',
    headerBarBanner = 'header-bar-banner-v2',
    headerBarBannerDismissBtn = 'header-bar-banner-v2-dismiss',
    headerLogoLink = 'header-logo-link',
    headerMenuButton = 'burger_menu_icon',
    headerShippingInfo = 'header-info-shipping',
    headerBackButton = 'header-back-button',
    navigationFlyoutBackdrop = 'backdropShadow',
    backInStockContainer = 'back-in-stock-container',
    backInStockEmailField = 'back-in-stock-email-field',
    backInStockButton = 'back-in-stock-btn',
    loginRegisterEmailField = 'long-register-email-field',
    loginRegisterPasswordField = 'long-register-password-field',
    alreadySetReminderText = 'already-set-reminder',
    categoriesBubblesSlider = 'categories-bubbles-slider',
    navigationThumbnailsPanel = 'navigation-thumbnails-panel',
    navigationThumbnails = 'navigation-thumbnails',
    navigationThumbnailsLabel = 'navigation-thumbnails-label',
    crossCategoryNavigation = 'cross-category-navigation',
    colorVariantItem = 'color-variant-item',
    backToTopButton = 'back-to-top-button',
    dynamicSearchSuggestionsItem = 'dynamic-search-suggestion-item',
    energyEfficiencyLabel = 'energy-efficiency-label',
    energyEfficiencyLabelPDP = 'pdp-energy-efficiency-label',
    wishlistIcon = 'wishlist-icon',
    homepageSingleLookPromotion = 'homepage-single-look-promotion',
    homepageSingleLookPromotionTitle = 'homepage-single-look-promotion-title',
    homepageSingleLookPromotionImage = 'homepage-single-look-promotion-image',
    homepageSingleLookPromotionCta = 'homepage-single-look-promotion-cta',
    homepageSingleLookPromotionCtaDesktop = 'homepage-single-look-promotion-cta-desktop',
    homepageSingleLookPromotionProduct = 'homepage-single-look-promotion-product',
    externalSortBox = 'external-sort-box',
    inlineSortBox = 'inline-sort-box',
    boxedFilter = 'boxed-filter',
    genericProduct = 'generic-product',
    promotionBarItem = 'promotion-bar-item',
    flyoutDismissButton = 'flyout-dismiss-click',
    rateYourProductPopup = 'rate_your_product',

    // PDP
    pdpGalleryRoot = 'pdp-gallery-root',
    pdpGalleryMainImageSliderWrapper = 'pdp-gallery-main-image-slider-wrapper',
    selectedColorVariantItem = 'selected-color-variant-item',
    UnselectedColorVariantItem = 'unselected-color-variant-item',
    pdpImageThumbnail = 'pdp-image-thumbnail',
    pdpSliderLeftArrow = 'pdp-slider-left-arrow',
    pdpSliderRightArrow = 'pdp-slider-right-arrow',
    pdpSliderContainer = 'horizontal-slider',
    pdpSliderImage = 'pdp-slider-image',
    pdpSliderSlide = 'pdp-slider-slide',
    pdpSliderThreeDImageCTA = 'pdp-slider-three-d-image-cta',
    pdpMobileThreeDImageCTA = 'pdp-mobile-three-d-image-cta',
    pdpThreeDImageCTAWrapper = 'pdp-three-d-image-cta-wrapper',
    pdpWishListBadgeWrapper = 'pdp-wish-list-badge-wrapper',
    pdpThreeDModelViewerLoader = 'pdp-three-d-model-viewer-loader',
    pdpThreeDModelViewerZoomInButton = 'pdp-three-d-model-viewer-zoom-in-button',
    pdpThreeDModelViewerZoomOutButton = 'pdp-three-d-model-viewer-zoom-out-button',
    pdpColorVariantImage = 'pdp-color-variant-image',
    productTitlePdp = 'product-title-pdp',
    pdpSizeSelector = 'pdp-size-selector',
    pdpSizeSelectorOverlay = 'pdp-size-selector-overlay',
    pdpAdditionalSimplesSelector = 'pdp-additional-simples-selector',
    pdpAdditionalSimplesSelectorOverlay = 'pdp-additional-simples-selector-overlay',
    pdpAddOnOverlay = 'pdp-add-on-overlay',
    pdpAddOnOverlayHeader = 'pdp-add-on-overlay-header',
    pdpAddOnOverlayClose = 'pdp-add-on-overlay-close',
    pdpSizeSelectorItem = 'pdp-size-selector-item',
    pdpAdditionalSimplesSelectorItem = 'pdp-additional-simples-selector-item',
    pdpAvailableAdditionalSimplesSelectorItem = 'pdp-additional-simples-selector-available-item',
    pdpAdditionalSimplesSelectorNoSelectionItem = 'pdp-additional-simples-selector-no-selection-item',
    pdpSelectorOption = 'pdp-selector-option',
    pdpSizeSelectorItemPrice = 'pdp-size-selector-item-price',
    pdpAdditionalSimplesSelectorItemPrice = 'pdp-additional-simples-selector-item-price',
    pdpAdditionalSimplesSelectorItemNotAvailable = 'pdp-additional-simples-selector-item-not-available',
    pdpSizeSelectorArrow = 'pdp-size-selector-arrow',
    pdpSelectorLabel = 'pdp-selector-label',
    pdpSelectorDropdown = 'pdp-selector-dropdown',
    pdpProductPrice = 'pdp-product-price',
    pdpAddToCartBtn = 'pdp-add-to-cart-btn',
    pdpRelatedProducts = 'pdp-related-products',
    pdpRecentlyViewedProducts = 'pdp-recently-seen-products',
    pdpDeliveryTimes = 'delivery-times-component',
    pdpSimilarProducts = 'pdp-similar-products',
    pdpValueProps = 'pdp-value-props-component',
    pdpTwoManHandlingSlide = 'two-man-handling-slide',
    pdpTwoManHandlingText = 'two-man-handling-txt-001',
    pdpDeliveryTimeValue = 'delivery-time-value',
    pdpQuantitySelector = 'pdp-quantity-selector',
    pdpAdditionalQuantitySelector = 'pdp-additional-quantity-selector',
    nativeVideoPlayIcon = 'native-video-play-icon',
    pdpMainDetailTabContent = 'pdp-main-detail-tab-content',
    pdpMainDetailTabSection = 'pdp-main-detail-tab-section',
    pdpMainDetailTab = 'pdp-main-detail-tab',
    pdpFabricSample = 'pdp-fabric-sample',
    pdpFabricSampleConfirmationButton = 'pdp-fabric-sample-confirmation-button',
    plpSimilarLinksSlider = 'plp-similar-links-slider',
    pdpFabricSampleOrder = 'pdp-fabric-sample-order',
    pdpFabricSampleOverlay = 'pdp-fabric-sample-overlay',
    pdpColorVariants = 'pdp-color-variants',
    pdpColorVariantsColorSelectorV1 = 'pdp-color-variants-color-selector-v1',
    pdpColorVariantsColorSelectorV2 = 'pdp-color-variants-color-selector-v2',
    pdpColorVariantsShowMoreButton = 'pdp-color-variants-show-more-button',
    pdpColorVariantsShowLessButton = 'pdp-color-variants-show-less-button',
    pdpSustainabilityBadge = 'sustainability-badge',
    pdpSalesBadge = 'sales-badge',
    pdpNewBadge = 'pdp-new-badge',
    pdpProductBrand = 'pdp-product-brand',
    energyEfficiencyDataSheet = 'energy-efficiency-data-sheet',
    pdpAssemblyServiceOverlay = 'assembly-service-add-to-cart',
    pdpAssemblyServiceOverlayCloseButton = 'assembly-service-add-to-cart-close-btn',
    pdpShippingOverlay = 'pdp-shipping-overlay',

    // PDP reviews
    pdpReviewsInner = 'reviews-inner',
    pdpDetailsTabRatingsBar = 'pdp-details-tab-ratings-bar',
    pdpDetailsTabReviewsShowMoreBtn = 'pdp-details-tab-reviews-show-more',
    pdpDetailsTabReviewsSpinner = 'pdp-detail-tab-reviews-spinner',
    pdpDetailsTabReview = 'pdp-details-tab-review',

    // PDP Looks Infusion
    pdpLooksInfusionVariantBottom = 'looks-infusion-variant-bottom',
    pdpLooksInfusionObserverPlaceholder = 'looks-infusion-observer-placeholder',
    pdpLooksInfusionMoodImage = 'looks-infusion-mood-image',
    pdpLooksInfusionLastTile = 'looks-infusion-last-tile',
    pdpLooksInfusionCta = 'looks-infusion-cta',
    pdpLooksInfusionSkeleton = 'looks-infusion-skeleton',

    // LDP Connected Looks
    ldpPrevLookLink = 'ldp-prev-look-link',
    ldpNextLookLink = 'ldp-next-look-link',
    ldpPlaceholderLookLink = 'ldp-placeholder-look-link',

    // Navigation flyout header
    NFHBackBtn = 'back_btn',
    NFHRightCloseBtn = 'right_close_btn',
    NFHMenuHeader = 'menu-header',
    NFHMenuTitle = 'menu-title',
    NFHPromoCard = 'promotion-card',

    // PLP
    plpNoFilterResultsMainText = 'plp-no-filter-results-main-text',
    plpNoFilterResultsSecondaryText = 'plp-no-filter-results-secondary-text',
    plpNoFilterResultsActionButton = 'plp-no-filter-results-action-button',
    plpStandardFilterGroupItem = 'plp-standard-filter-group-item',
    plpFilterProductsCountDesktop = 'plp-filter-products-count-desktop',
    plpFilterProductsCountMobile = 'plp-filter-products-count-mobile',
    plpFilterToggleButton = 'plp-filter-toggle-button',
    plpSidebarCategoriesLabelDesktop = 'plp-sidebar-categories-label-desktop',
    plpSidebarCategoriesNavDesktop = 'plp-sidebar-categories-nav-desktop',
    // LLP
    llpBackButton = 'llp-back-button',
    llpSpinner = 'looks-listing-spinner',

    plpProductsGrid = 'plp-products-grid',
    plpAlternativeProductsGrid = 'plp-alternative-products-grid',
    plpAlternativeProductsTitle = 'plp-alternative-products-title',

    // Unblock Overlay
    unblockUserOverlayAcceptBtn = 'unblock-user-overlay-accept-btn',
    unblockUserOverlayDenyBtn = 'unblock-user-overlay-deny-btn',
    unblockUserOverlayDenyErrorMessage = 'unblock-user-overlay-deny-error-msg',

    zoomOverlayWrapper = 'zoom-overlay-wrapper',

    klarnaBadge = 'klarna_badge',
}

export enum OneHeaderIds {
    clubTab = 'club-tab',
    clubTabBubble = 'club-tab-bubble',
    wishlistBubble = 'wishlist-bubble',
    wishlistCounter = 'wishlist-counter',
    accountIcon = 'one-header-icon-my-account',
    westWingStudioIcon = 'one-header-icon-westwing-studio',
    cartIcon = 'one-header-icon-cart',
    search = 'search-wrapper',
    searchDropdown = 'search-dropdown-wrapper',
    searchOverlayTitle = 'search-overlay-title',
    searchInputIcon = 'search-input-icon',
    searchOverlayCloseButton = 'search-close-btn',
    searchSuggestion = 'suggestions',
    desktopNavigation = 'header-navigation-desktop-wrapper',
    mobileNavigation = 'turquoise-nav-bar',
    userName = 'one-header-account-name',
    oneHeader = 'one-header',
}

export enum OneWestwingFooterIds {
    owwFooter = 'oww-footer',
    owwCountrySelector = 'oww-footer-country-selector',
    owwCountrySelectorOverlay = 'oww-footer-country-selector-overlay',
    owwCountrySelectorOverlaySubmit = 'oww-footer-country-selector-overlay-submit',
    owwCountrySelectorOverlayMobile = 'oww-footer-country-selector-overlay-mobile',
    owwCountrySelectorMobile = 'oww-footer-country-selector-mobile',
    owwLinksAGB = 'oww-footer-links-agb',
}
